import Image from 'next/image';
import { Typography } from '@/shared/ui/atoms';

interface ProblemItemProps {
  icon: string;
  text: string;
}

const ProblemItem = ({ icon, text }: ProblemItemProps) => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  return (
    <div className="h-[110px] px-6 flex items-center gap-3 rounded-[16px] bg-[#383A4D]">
      <Image src={`${baseImageUrl}/home/icon-${icon}.svg`} alt="problem" width={24} height={24} />
      <Typography className="text-white text-[18px] md:text-[24px] font-semibold leading-[130%] tracking-[-0.27px] md:tracking-[-0.36px]" dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};

export default ProblemItem;
